import type {NavigationGuardReturn, RouteLocationNormalized} from 'vue-router';
import {useUserStore} from '@/stores/userStore';
import {saveRoute} from '../guardHelper';
import DesklyConnectRepository from '../../api/repositories/DesklyConnectRepository';

export async function handleAuthorizeSensor(
    to: RouteLocationNormalized
): Promise<NavigationGuardReturn> {
    const {isAuthenticated} = useUserStore();

    // Check if user is authenticated first
    if (!isAuthenticated) {
        saveRoute(to);
        return {name: 'Login'};
    }

    const sensorId = to.query.sensorId as string;
    const target = to.query.target as string | undefined;

    if (!sensorId) {
        return {name: 'AuthorizeSensorFailed', query: {sensorId, target}};
    }

    try {
        const result = await DesklyConnectRepository().authorizeSensor(sensorId, target);

        if (result.success) {
            return;
        }
    } catch {
        // Error already handled by api.error (toast shown)
        // Redirect to failure page
        return {name: 'AuthorizeSensorFailed', query: {sensorId, target}};
    }

    // If we get here, something went wrong
    return {name: 'AuthorizeSensorFailed', query: {sensorId, target}};
}
